import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import CleanMindPrivacyPolicy from './components/CleanMindPrivacyPolicy';
import ArtrixPrivacyPolicy from './components/ArtrixPrivacyPolicy';
import ArtrixTermsOfService from './components/ArtrixTermsOfService';
import AiDGPrivacyPolicy from './components/AiDGPrivacyPolicy';
import AiDGTermsOfService from './components/AiDGTermsOfService';
import BankStatementConverterPrivacyPolicy from './components/BankStatementConverterPrivacyPolicy';
import CPGPrivacyPolicy from './components/CPGPrivacyPolicy';
import OneTapPrivacyPolicy from './components/OneTapPrivacyPolicy';
import { useDarkMode } from './hooks/useDarkMode';

function App() {
  const { darkMode, toggleDarkMode } = useDarkMode();

  const HomePage = () => (
    <>
      <Hero />
      <About />
      <Contact />
    </>
  );

  return (
    <Router>
      <div style={{ minHeight: '100vh' }}>
        <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/apps/ocracle/privacy-policy" element={<PrivacyPolicy appName="OCRacle" />} />
            <Route path="/apps/cleanmind/privacy-policy" element={<CleanMindPrivacyPolicy />} />
            <Route path="/apps/artrix/privacy-policy" element={<ArtrixPrivacyPolicy />} />
            <Route path="/apps/artrix/terms-of-service" element={<ArtrixTermsOfService />} />
            <Route path="/apps/aidg/privacy-policy" element={<AiDGPrivacyPolicy />} />
            <Route path="/apps/aidg/terms-of-service" element={<AiDGTermsOfService />} />
            <Route path="/apps/bank-statement-converter/privacy-policy" element={<BankStatementConverterPrivacyPolicy />} />
            <Route path="/apps/cpg/privacy-policy" element={<CPGPrivacyPolicy />} />
            <Route path="/apps/onetap/privacy-policy" element={<OneTapPrivacyPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
